module.exports = __webpack_public_path__ + "static/media/feed.f413de03.gif";